module.exports = __webpack_public_path__ + "img/里程.5a2fe811.svg";